module.exports = __webpack_public_path__ + "static/media/videodark.a9ff53db.svg";